import type { User } from "@src/stores/auth"

// TODO: Add wallet type
export const getSpecialBonusData = (me: null | User, wallet) => {
  const pendingKycBonuses = me?.pendingKycBonuses ?? []
  const hasPendingKycBonuses = pendingKycBonuses.length > 0

  const gamblerWallet = wallet.wallets.find((w) => w.campaign?.meta?.playable)

  const shouldShowSpecialBonusWallet = hasPendingKycBonuses || Boolean(gamblerWallet)

  if (!shouldShowSpecialBonusWallet) return { balance: 0, currency: '' }

  const balance = gamblerWallet?.balance || pendingKycBonuses[0]?.amount || 0

  // TODO: Maybe we should set a global constant for the default/fallback currency
  const currency = gamblerWallet?.currency || pendingKycBonuses[0]?.currency || 'BTC'

  return { balance, currency }
}
